import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from "vue";
import Chart from 'primevue/chart';

interface ChartLineType {
  label: string;
  data: number[];
  fill?: boolean;
  backgroundColor?: string;
  borderColor?: string;
  tension?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'chart-bar',
  props: {
    labels: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const chartData = ref();
const chartOptions = ref();

const setChartData = () => {
  return {
    labels: props.labels,
    datasets: props.data,
  };
};

const setChartOptions = () => {
  return {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        labels: {
          color: "#000000",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#181818",
          font: {
            weight: 500,
          },
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        ticks: {
          color: "#181818",
        },
        grid: {
          color: "transparent",
          drawBorder: false,
        },
      },
    },
  };
};

onMounted(() => {
  chartData.value = setChartData();
  chartOptions.value = setChartOptions();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), {
    class: "chart-bar",
    type: "bar",
    data: chartData.value,
    options: chartOptions.value
  }, null, 8, ["data", "options"]))
}
}

})